import { createObjectEventRouter } from '../game/object-events.js';
import { useCatPuzzleStore } from '../state/cat-puzzle.js';
import { useDeskStore } from '../state/desk.js';
import { usePinDoorStore } from '../state/pin-door.js';
import { useSessionStore } from '../state/session-store.js';
import { registerBoardEvents } from './board-event-handlers.js';

/** Routes `object:event` messages to what they do on screen (spec §6.6). */
export const objectEvents = createObjectEventRouter();

// The wall calendar opens the birthday calendar panel (spec §6.13).
objectEvents.on('wall_calendar', 'open', () => useSessionStore.getState().setCalendarOpen(true));

// Whiteboard and bulletin board panels (spec §6.15).
registerBoardEvents(objectEvents);
// Mini-game stations open their panel when the server says the player has a spot (spec §6.14).
objectEvents.on('dance_floor', 'open', (event) =>
  useSessionStore.getState().setGamePanel({ objectId: event.objectId, kind: 'dance' }),
);
objectEvents.on('ping_pong_table', 'open', (event) =>
  useSessionStore.getState().setGamePanel({ objectId: event.objectId, kind: 'pong' }),
);
// Cat Scholes opens the puzzle (spec §6.14.4).
objectEvents.on('cat_spot', 'open', (event) => useCatPuzzleStore.getState().openAt(event.objectId));

// The PIN door's answer to a keyed in PIN (ADR-0039).
objectEvents.on('pin_door', 'authorized', (event) =>
  usePinDoorStore.getState().authorize(event.objectId),
);
objectEvents.on('pin_door', 'wrong', (event) =>
  usePinDoorStore.getState().setFeedback({
    kind: 'wrong',
    attemptsLeft: (event.data as { attemptsLeft: number }).attemptsLeft,
  }),
);
objectEvents.on('pin_door', 'locked', (event) =>
  usePinDoorStore.getState().setFeedback({
    kind: 'locked',
    retryAt: (event.data as { retryAt: number }).retryAt,
  }),
);

// Desks (ADR-0042): the server's answer to E, then to the player's choice.
objectEvents.on('desk', 'prompt', (event) =>
  useDeskStore.getState().show({
    objectId: event.objectId,
    ...(event.data as { name: string; state: 'free' | 'mine' | 'taken'; holder?: string }),
  }),
);
const deskChanged = (event: { data?: unknown }) => {
  const { user, setUser } = useSessionStore.getState();
  if (user)
    setUser({
      ...user,
      deskObjectId: (event.data as { deskObjectId: number | null }).deskObjectId,
    });
  useDeskStore.getState().close();
};
objectEvents.on('desk', 'assigned', deskChanged);
objectEvents.on('desk', 'released', deskChanged);
objectEvents.on('desk', 'taken', () => useDeskStore.getState().setProblem('taken'));
objectEvents.on('desk', 'failed', () => useDeskStore.getState().setProblem('failed'));
